module.exports = __webpack_public_path__ + "static/media/kgp-slide-5.22fd8854.jpg";